import React, { useEffect, useState } from 'react';

import CloseIcon from '@material-ui/icons/Close';
import { Typography } from '@material-ui/core';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { Trans } from 'react-i18next';

import { AutocompleteValidatorComponent } from 'components/FormComponents';
import { ButtonComponent } from 'components/ButtonComponent/ButtonComponent';
import { VALIDATORS_MAP } from 'components/FormComponents/const';
import { SphereTemplate } from 'types';
import { getTWithPathKey } from 'utils';

import { Box, Dialog, DialogActions, DialogCloseButton, DialogContent, DialogTitle } from '../style';

interface DefaultTemplateDialogProps {
  templateSettings: SphereTemplate;
  templatesList: SphereTemplate[];
  handleChange: (item: Partial<SphereTemplate>) => void;
  show: boolean;
  setShow: (val: boolean) => void;
}

export const DefaultTemplateDialog = ({
  templateSettings,
  templatesList,
  handleChange,
  show,
  setShow,
}: DefaultTemplateDialogProps) => {
  const getT = getTWithPathKey('pages.planograms.managePlanograms.defaultTemplateDialog');
  const getCommonT = getTWithPathKey('common.buttons');
  const defaultTemplateName = templatesList.find(template => template.isDefault)?.title;

  const handleClose = () => setShow(false);

  const onSubmit = () => {
    const data = {
      defaultTemplateId: templateSettings.isDefault ? templateSettings.defaultTemplateId : null,
      isDefault: templateSettings.isDefault ? templateSettings.id === templateSettings.defaultTemplateId : true,
    };

    handleChange(data);
    handleClose();
  }

  return (
    <Dialog open={show} onClose={handleClose} fullWidth>
      <div className="titleWrapper">
        <DialogTitle>{getT(`${templateSettings?.isDefault ? 'default' : 'regular'}.title`)}</DialogTitle>
      </div>
      <DialogCloseButton onClick={handleClose}>
        <CloseIcon color="action" />
      </DialogCloseButton>
      <ValidatorForm onSubmit={onSubmit}>
        <DialogContent className="cloneDialog">
          <Box mb={4}>
            <Typography>
              <Trans
                i18nKey={`pages.planograms.managePlanograms.defaultTemplateDialog.${templateSettings?.isDefault ? 'default' : 'regular'}.description`}
                components={{ bold: <b /> }}
                values={{ planogramName: templateSettings?.title, usedPlanogram: defaultTemplateName }}
              />
            </Typography>
          </Box>
          {templateSettings?.isDefault && (
            <Box mb={4}>
              <Box>
                <AutocompleteValidatorComponent
                  value={templateSettings?.defaultTemplateId}
                  fieldName="defaultTemplateId"
                  handleChange={handleChange}
                  disableClearable
                  selectList={templatesList}
                  itemsNamePath="title"
                  label="Select Default Template"
                  validators={[VALIDATORS_MAP.required]}
                  disableMinHeight
                />
              </Box>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <ButtonComponent onClick={handleClose} text={getCommonT('cancel')} />
          <ButtonComponent
            type="submit"
            color="primary"
            text={getCommonT('ok')}
          />
        </DialogActions>
      </ValidatorForm>
    </Dialog>
  )
}
